import { render, staticRenderFns } from "./RinvD_Details.vue?vue&type=template&id=13c85d35"
import script from "./RinvD_Details.vue?vue&type=script&lang=js"
export * from "./RinvD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports